<template>
  <div
    v-if="applicationReady && componentReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          v-if="!formSubmitted"
          cols="12"
        >
          <b-row>
            <b-col cols="12">
              <b-row class="question-errors">
                <b-col
                  v-if="$v.formAnswers.immunizationType.$error || ($v.formAnswers.immunizationDate.$error && !formAnswers.declined)"
                  cols="12"
                  class="pb-3"
                >
                  <div
                    class="invalid-feedback"
                  >
                    <h3>Immunization type and immunization date are required!</h3>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="text-center pb-4"
                  >
                    <h1>
                      Immunization Type
                    </h1>
                  </b-col>
                </b-row>
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="pb-3"
                  >
                    <b-form-select
                      size="lg"
                      v-model="formAnswers.immunizationType"
                      :options="[
                        {value: null, text: 'Immunization Type'},
                        {
                          label: 'Annual Influenza vaccination',
                          options: [
                            {value: 'Influenza Regular Dose', text: 'Regular Dose'},
                            {value: 'Influenza High Dose', text: 'High Dose'},
                          ]
                        },
                        {value: 'Influenza Booster', text: 'Influenza Booster'},
                        {value: 'COVID Booster', text: 'COVID Booster'},
                        {value: 'Pneumonia Vaccine', text: 'Pneumonia Vaccine'}
                      ]"
                    />
                  </b-col>
                </b-form-row>
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="text-center pb-4"
                  >
                    <h1>
                      Immunization Date
                    </h1>
                  </b-col>
                </b-row>
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="pb-3"
                  >
                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="formAnswers.immunizationDate"
                      class="mb-2"
                      :max="max"
                      :disabled="formAnswers.immunizationDeclined"
                      :date-format-options="dateFormatOptions"
                    />
                  </b-col>
                </b-form-row>
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="text-center pb-4"
                  >
                    <h1>
                      Immunization Side Effects
                    </h1>
                  </b-col>
                </b-row>
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="pb-3"
                  >
                    <b-form-textarea
                      v-model="formAnswers.immunizationSideEffects"
                      :disabled="formAnswers.immunizationDeclined"
                    />
                  </b-col>
                </b-form-row>
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    offset-md="3"
                    class="text-center pb-4"
                  >
                    <h1>
                      Declined Immunization
                    </h1>
                  </b-col>
                </b-row>
                <b-form-row class="question-answer">
                  <b-col
                    cols="4"
                    offset="4"
                    class="pb-3"
                  >
                    <div class="question-checkboxes">
                      <b-form-checkbox
                        class="question-checkbox"
                        size="lg"
                        v-model="formAnswers.immunizationDeclined"
                        text-field="answer_text"
                        value-field="answer_value"
                      >
                        <div class="text-center">
                          Declined
                        </div>
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="formSubmitted"
          cols="12"
          class="screening-complete"
        >
          <b-row>
            <b-col
              cols="12"
              class="screening-complete-title"
            >
              <span class="success-message exit">
                <h1>
                  Screening Complete!
                </h1>
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="false"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="previousPage"
                  :disabled="true"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-left-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click.stop.prevent="submitForm"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted && !isSelfMode"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <b-modal
      v-model="showFailedScreeningModal"
      id="failed-screening"
      modal-class="failed-screening"
      centered
      no-close-on-esc
      hide-header
      hide-footer
    >
      <div class="failed-screening-icon">
        <img
          src="../assets/warning-icon.png"
          class="icon"
        >
      </div>

      <p class="my-4 text-center">
        Confirm {{ selectedUser.itemName }} {{ failureModalDescription }}
      </p>

      <b-row>
        <b-col
          cols="12"
          class="pb-3 text-left"
        >
          <b-button
            variant="green"
            class="failed-screening-option"
            @click.stop.prevent="submitFormFailure"
          >
            Confirm &raquo;
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
        >
          <b-button
            variant="green"
            class="failed-screening-option"
            @click="showFailedScreeningModal = !showFailedScreeningModal"
          >
            &laquo; Go back
          </b-button>
        </b-col>
      </b-row>

      <template v-slot:modal-header-close>
        &nbsp;
      </template>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import mixin from '../mixins/forms.js'

export default {
  middleware: 'auth',
  name: 'ExitScreening',
  mixins: [mixin],
  data () {
    return {
      formAnswers: {
        immunizationType: null,
        immunizationDate: '',
        immunizationSideEffects: '',
        immunizationDeclined: false
      }
    }
  },
  validations: {
    formAnswers: {
      immunizationType: {
        required
      },
      immunizationDate: {
        required
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    componentReady () {
      if (this.loggedIn) {
        return this.currentQuestionnaire !== undefined && this.questions !== undefined
      }
      return false
    },
    questionDate () {
      if (this.componentReady) {
        return this.findQuestionBySection('enterDateOfExit')
      }
      return {}
    },
    questionTime () {
      if (this.componentReady) {
        return this.findQuestionBySection('enterTimeOfExit')
      }
      return {}
    }
  },
  watch: {
    currentQuestionnaire: {
      handler: function (newQuestionnaire, oldQuestionnaire) {
        if (newQuestionnaire !== undefined) {
          const date = new Date()
          const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric', hour12: false })
          const [{ value: month },, { value: day },, { value: year },, { value: hour },, { value: minute }] = dateTimeFormat.formatToParts(date)

          this.formAnswers.enterDateOfExit = year + '-' + month + '-' + day
          this.formAnswers.enterTimeOfExit = hour + ':' + minute + ':00'
        }
      },
      deep: true
    }
  },
  methods: {
    async init () {
      await this.setCurrentDateAndTime('exit')
      await this.setCurrentPage(1)
      await this.isSingleStep()
    },
    submitForm () {
      this.$v.formAnswers.$touch()
      if (!this.$v.formAnswers.immunizationType.$invalid && (!this.$v.formAnswers.immunizationDate.$invalid || (this.$v.formAnswers.immunizationDate.$invalid && this.formAnswers.immunizationDeclined))) {
        this.setFormSubmitted(!this.formSubmitted)
        this.addFormResults(this.answersById)
      }
    },
    submitFormFailure () {
      this.setFailedScreening(true)
      this.showFailedScreeningModal = !this.showFailedScreeningModal
      this.submitForm()
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-bottom {
  text-align: center;
}
</style>
